// removed by extract-text-webpack-plugin
module.exports = {"container":"src-modules-app-__App__container--3DQ_t","alerts":"src-modules-app-__App__alerts--2Mph7","alert":"src-modules-app-__App__alert--3EsPI"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/app/App.less
// module id = 1876
// module chunks = 0